import { lazy } from 'react';

// Tenant governance
export const LicenseDashboard = lazy(() =>
  import('@/capabilities/tenant-governance/pages/LicenseDashboard').then((m) => ({ default: m.LicenseDashboard }))
);

export const LicenseManagementPage = lazy(() =>
  import('@/capabilities/tenant-governance/pages/LicenseManagementPage').then((m) => ({ default: m.LicenseManagementPage }))
);

export const UsagePage = lazy(() =>
  import('@/capabilities/tenant-governance/pages/UsagePage').then((m) => ({ default: m.UsagePage }))
);

export const MfaEnrollmentPage = lazy(() =>
  import('@/capabilities/tenant-governance/pages/MfaEnrollmentPage').then((m) => ({ default: m.MfaEnrollmentPage }))
);

export const AdminGuardPage = lazy(() =>
  import('@/capabilities/tenant-governance/pages/AdminGuardPage').then((m) => ({ default: m.AdminGuardPage }))
);
